import format from 'date-fns/format'
import startOfMonth from 'date-fns/startOfMonth'
import startOfWeek from 'date-fns/startOfWeek'
import startOfYear from 'date-fns/startOfYear'
import store from '@/services/store'
import subDays from 'date-fns/subDays'
import subMonths from 'date-fns/subMonths'
import { getDeepProperty } from '@/helpers/deepObject.js'

export function getApiFriendlyTimeframe (time) {
  let timeframe = {}
  timeframe.start = time.start ? format(new Date(time.start), 'yyyy-MM-dd') : null
  timeframe.end = time.end ? format(new Date(time.end), 'yyyy-MM-dd') : null
  timeframe.label = time.label ? time.label : null
  return timeframe
}

export function getTimeframePickerDefaultOptions (defaultKey) {
  let options = [
    {
      label: 'Today',
      start: new Date(),
      end: new Date(),
      key: 'today',
      default: defaultKey === 'today'
    },
    {
      label: 'Yesterday',
      start: subDays(new Date(), 1),
      end: subDays(new Date(), 1),
      key: 'yesterday',
      default: defaultKey === 'yesterday'
    },
    {
      label: 'Last 7 Days (including today)',
      start: subDays(new Date(), 6),
      end: new Date(),
      key: 'last7',
      default: defaultKey === 'last7' || !defaultKey
    }
  ]

  options.push(
    {
      label: 'Last Week',
      start: subDays(startOfWeek(new Date()), 7),
      end: subDays(startOfWeek(new Date()), 1),
      key: 'lastWeek',
      default: defaultKey === 'lastWeek'
    },
    {
      label: 'Last 30 Days (including today)',
      start: subDays(new Date(), 30),
      end: new Date(),
      key: 'last30',
      default: defaultKey === 'last30'
    }
  )

  options.push(
    {
      label: 'Last Month',
      start: subMonths(startOfMonth(new Date()), 1),
      end: subDays(startOfMonth(new Date()), 1),
      key: 'lastMonth',
      default: defaultKey === 'lastMonth'
    },
    // Year from current date explained:
    // Get Jan 1st of this year - Subtract 1 day to get Dec 31 of last year (end)
    // Get start of year again to get previous years Jan 1st (start)
    {
      label: 'Last Year',
      start: startOfYear(subDays(startOfYear(new Date()), 1)),
      end: subDays(startOfYear(new Date()), 1),
      key: 'lastYear',
      default: defaultKey === 'lastYear'
    },
    {
      label: 'All Time',
      start: null,
      end: null,
      key: 'allTime',
      default: defaultKey === 'allTime'
    }
  )

  if (getDeepProperty(store, 'getters.activePodcast.features.has_premium_analytics')) {
    options.push(
      {
        label: 'Since Release: First 7 Days', // From published_at until 7 days after published_at
        relative: 7, // Adding the additional day for graph legibility purposes
        key: 'first7release',
        default: defaultKey === 'first7release'
      },
      {
        label: 'Since Release: First 30 Days', // From published_at until 30 days after published_at
        key: 'first30release',
        relative: 30, // Adding the additional day for graph legibility purposes
        default: defaultKey === 'first30release'
      }
    )
  }

  return options
}
